import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TuiInputModule } from '@taiga-ui/kit';
import { TuiButtonModule, TuiTextfieldControllerModule } from '@taiga-ui/core';
import { phoneMask } from '@shared/utils/masks';
import { AutocompleteComponent } from '@shared/components/forms/autocomplete/autocomplete.component';
import {
  ContactType,
  OrganizationMemberContactForm,
  OrganizationMemberForm,
} from '../../../../types/organization-member';

@Component({
  selector: 'app-organization-member',
  standalone: true,
  imports: [
    TuiInputModule,
    TuiTextfieldControllerModule,
    ReactiveFormsModule,
    TuiButtonModule,
    AutocompleteComponent,
  ],
  templateUrl: './organization-member.component.html',
  styleUrl: './organization-member.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationMemberComponent {
  @Input() last!: boolean;
  @Output() create = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();
  @Input() memberForm!: FormGroup<OrganizationMemberForm>;
  protected readonly phoneMask = phoneMask;

  contactTypes = [
    {
      text: 'Тел.',
      value: ContactType.PHONE,
    },
    {
      text: 'Email',
      value: ContactType.EMAIL,
    },
    {
      text: 'Telegram',
      value: ContactType.TELEGRAM_NICKNAME,
    },
  ].map(i => ({ ...i, itemSearch: `${i.text}-${i.value}` }));

  constructor(private readonly fb: FormBuilder) {}

  addContact() {
    this.memberForm.controls.contacts.push(
      this.fb.group<OrganizationMemberContactForm>({
        type: this.fb.control(null),
        value: this.fb.control(null),
      }),
    );
  }

  removeContact(index: number) {
    this.memberForm.controls.contacts.removeAt(index);
  }
}
